import { combineReducers } from "redux";
import UserReducer from "./UserReducer";
import GamesDataReducer from "./GamesDataReducer";
import CouncilsDataReducer from "./CouncilsDataReducer";
import DistrictsDataReducer from "./DistrictsDataReducer";
import RegionsDataReducer from "./RegionsDataReducer";

const rootReducer = combineReducers({
  UserReducer,
  GamesDataReducer,
  CouncilsDataReducer,
  DistrictsDataReducer,
  RegionsDataReducer,
});

export default rootReducer;
